import NibbleLogoRed from "../../images/nibble-logo-red.svg";
import NibbleLogoBlue from "../../images/nibble-logo-blue.svg";
import NibbleLogoGreen from "../../images/nibble-logo-green.svg";
import NibbleLogoOrange from "../../images/nibble-logo-orange.svg";
import NibbleLogoPink from "../../images/nibble-logo-pink.svg";
import React from "react";
import {version} from "../../../package.json";

const images = [
    NibbleLogoRed,
    NibbleLogoBlue,
    NibbleLogoGreen,
    NibbleLogoOrange,
    NibbleLogoPink,
];

const numVersion = parseInt(version);
const colorIndex = numVersion % images.length;

type Props = {
    className?: string;
};

export function NibbleLogo({className}: Props) {
    return <img className={className} src={images[colorIndex]} alt="" />;
}
